import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import { ActionTableCellComponent } from "../action-table-component";
import { GreenRedSwitch } from "../switch/green-red-switch";
import TMSWebhookManagement from "./webhook-management";
import { tmsService } from "../../utils/services/tmsService";

const init = [{ webhook: { topic: "", address: "" } }];

const TransportManagement = ({
  onEditData,
  data,
  clientId,
  onViewTmsData,
  handleDeleteClick,
  addButton,
  onUpdateTms,
}) => {
  const [selectedProvider, setSelectedProvider] = useState(null);

  const updateStatus = async (id, status) => {
    try {
      const response = await tmsService.edit(
        {
          active: status,
        },
        id,
      );
      toast.success("Status updated successfully");
      onUpdateTms(response);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <Box>
      <React.Fragment>
        <TableContainer
          sx={{
            overflow: "auto",
            mt: 1,
            maxHeight: 500,
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Soft shadow
            border: "1px solid var(--border-color)", // Light grey border
            borderRadius: "8px", // Rounded corners for a cleaner look
          }}
          component={Paper}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "600",
                    backgroundColor: "var(--table-header-bg)",
                  }}
                >
                  Provider
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "600",
                    backgroundColor: "var(--table-header-bg)",
                  }}
                >
                  Webhook
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "600",
                    backgroundColor: "var(--table-header-bg)",
                  }}
                >
                  Status
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "600",
                    backgroundColor: "var(--table-header-bg)",
                  }}
                >
                  {addButton}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .map((item) => ({
                  ...item,
                  action: (
                    <ActionTableCellComponent
                      selectedData={item}
                      handleViewClick={(data) =>
                        onViewTmsData && onViewTmsData(data)
                      }
                      handleEditClick={(data) => onEditData && onEditData(data)}
                      handleDeleteClick={(data) =>
                        handleDeleteClick && handleDeleteClick(data)
                      }
                    ></ActionTableCellComponent>
                  ),
                }))
                ?.map((provider, i) => (
                  <TableRow
                    sx={{
                      backgroundColor:
                        i % 2 === 0
                          ? "var(--row-bg-odd)"
                          : "var(--row-bg-even)",
                    }}
                    key={i}
                  >
                    <TableCell>{provider?.provider?.name}</TableCell>
                    <TableCell>
                      <div
                        style={{
                          border: "0.5px solid var(--primary-blue)",
                          padding: 6,
                          borderRadius: 5,
                          display: "flex",
                          flexDirection: "row",
                          cursor: "pointer",
                          maxWidth: 130,
                        }}
                        onClick={() => setSelectedProvider(provider)}
                      >
                        <img alt="link" src="/link.png" />
                        <CustomTypography
                          fontSize={13}
                          style={{
                            color: "var(--primary-blue)",
                            marginLeft: 1,
                          }}
                        >
                          Webhook
                        </CustomTypography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <GreenRedSwitch
                        size="small"
                        checked={provider?.active}
                        onChange={() =>
                          updateStatus(provider._id, !provider.active)
                        }
                      />
                    </TableCell>
                    <TableCell sx={{ paddingRight: 0, display: "flex" }}>
                      {provider.action}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TMSWebhookManagement selectedProvider={selectedProvider} />
      </React.Fragment>
    </Box>
  );
};
export default TransportManagement;
